__webpack_require__.p = "https://cdn2.booqable.com/packs/";